<div class="wrapper">
    <div class="header">
        <div class="title">Select Imaging Studies</div>
        <button mat-icon-button (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="toolbar">
        <mat-form-field appearance="outline" class="filter">
            <mat-label>Filter</mat-label>
            <input matInput (input)="applyFilter(($any($event.target)).value)"
                placeholder="Search description, status, modality" />
        </mat-form-field>

        <button mat-stroked-button (click)="fetch()" [disabled]="loading">
            <mat-icon>refresh</mat-icon>
            Refresh
        </button>
    </div>

    @if (loading) {
    <div class="muted">Loading ImagingStudies…</div>
    }

    <div class="table">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
            @if (forSelection) {
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            }

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let row">
                    <div class="primary">{{ imagingTitle(row) }}</div>
                    <div class="secondary">ID: {{ row.imagingStudy.id ?? '—' }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">{{ row.imagingStudy.status ?? '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="modality">
                <th mat-header-cell *matHeaderCellDef>Modality</th>
                <td mat-cell *matCellDef="let row">{{ imagingModality(row) }}</td>
            </ng-container>

            <ng-container matColumnDef="started">
                <th mat-header-cell *matHeaderCellDef>Started</th>
                <td mat-cell *matCellDef="let row">{{ imagingStarted(row) }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns"
                (click)="forSelection ? selection.toggle(row) : null"></tr>
        </table>

        @if (!loading && dataSource.data.length === 0) {
        <div class="muted" style="padding: 12px 0;">No ImagingStudy found for these ServiceRequests.</div>
        }
    </div>

    @if (forSelection) {
    <div class="actions">
        <button mat-stroked-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" (click)="confirmSelection()">Add Selected ({{ selection.selected.length
            }})</button>
    </div>
    }
</div>